import { Component} from '@angular/core';
import { AppState } from '../../../../app/app.global';
import { HttpService } from '../../../../providers/service/httpservice';
import { ELECTIVERESULT,ESEMESTERLIST } from '../../../../providers/config/serviceurl';
import { StorageService } from '../../../../providers/service/storageservice';

@Component({
  selector: 'electiveresult',
  templateUrl: 'electiveresult.html'
})

export class ElectiveResult {
	yearList:any=[];
	semesterList:any=[];
	electiveresultList:any=[];
	semesters:any=[];
	selectSemeter:string;
	user:any;
	selectYear:string;
	constructor(public global: AppState,private httpService:HttpService) {
		this.user = StorageService.getObj('currentUser');
		this.semesters = StorageService.getObj('esemesters');
		this.yearList = StorageService.getObj('eyearList');
		this.semesterList = StorageService.getObj('esemesterList');
		this.electiveresultList = StorageService.getObj('electiveresultList');;
		this.httpService.get(ESEMESTERLIST,{"hd":this.user.hd}).then(anyObj => this.handleSemesterData(anyObj));
	}
	handleElectiveResultList(obj:any){
  	if(obj){
     this.electiveresultList = obj;
     StorageService.setObj("electiveresultList",this.electiveresultList);
		}
 }
	handleSemesterData(obj:any){
		if(obj&&obj.length>0){
      this.semesters = obj;
      this.yearList = [];
      StorageService.setObj("esemesters",this.semesters);
      for(let i=0;i<obj.length;i++){
      	if(this.yearList.indexOf(obj[i].sYear) < 0){
      		this.yearList.push(obj[i].sYear);
      	}
      }
       StorageService.setObj("eyearList",this.yearList);
      this.selectYear = this.semesters[0].sYear;
      this.semesterList = this.getSemesterByYear(this.semesters,this.selectYear);
      StorageService.setObj("esemesterList",this.semesterList);
      this.selectSemeter = this.semesterList[0].value;
      this.httpService.get(ELECTIVERESULT,{"hd":this.user.hd,"sYear":this.selectYear,"semester":this.semesterList[0].value}).then(anyObj => this.handleElectiveResultList(anyObj));
		}
	}
	changeSemeter(selectYear,selectSemeter){
		this.httpService.get(ELECTIVERESULT,{"hd":this.user.hd,"sYear":selectYear,"semester":selectSemeter}).then(anyObj => this.handleElectiveResultList(anyObj));
	}
	changeYear($event){
		 this.semesterList = this.getSemesterByYear(this.semesters,$event);
		 if(this.semesterList.length>0){
		 	 this.selectSemeter = this.semesterList[0].value;
		   this.httpService.get(ELECTIVERESULT,{"hd":this.user.hd,"sYear":this.selectYear,"semester":this.semesterList[0].value}).then(anyObj => this.handleElectiveResultList(anyObj));
		 }
		
	}
	getSemesterByYear(obj:any,year:string):any{
		let semesterArry = [];
		for(let i = 0; i < obj.length;i++){
			if(year == obj[i].sYear){
				let item = {};
				if(obj[i].semester == "1"){
					item = {"semester":"第一学期","value":"1"};
				}else if(obj[i].semester == "2"){
					item = {"semester":"第二学期","value":"2"};
				}
				semesterArry.push(item)
			}
    }
		return semesterArry;
	}
	loadMore(refresher){
    setTimeout(() => {
      refresher.complete();
    }, 500);
  }
  //下拉刷新
  doRefresh(refresher){
    setTimeout(() => {
      refresher.complete();
    }, 1000);
  }
}


// WEBPACK FOOTER //
// ./src/pages/application/teaching/elective/electiveresult.ts